import { WishlistSize } from './WishlistButton.types';

export const WISHLIST_CONFIG = {
  ariaLabel: {
    add: 'Add to shortlist',
    remove: 'Remove from shortlist'
  },
  icons: {
    active: '/icons/wishlist-favourite.svg',
    inactive: '/icons/wishlist.svg'
  },
  messages: {
    loginRequired: 'Please log in first'
  },
  iconSizes: {
    small: 16,
    medium: 24,
    large: 32
  } as Record<WishlistSize, number>
}; 